module.exports = __webpack_public_path__ + "static/media/received_453712608592054_mh1572548099293.c094af44.jpg";